import { FC, SyntheticEvent, useEffect, useState } from 'react';
import { useLoaderData, useParams } from 'react-router-dom';
import { bakery2bTabLoadingService } from '../bakery2bTabLoading.service';
import { navigateService } from '../../../../shared/services/navigate/navigate.service';
import { transitionService } from '../../../../shared/components/loading/service/transition.service';
import { TCompanyConfigs } from '../../../../shared/services/companyConfig/companyConfig.service';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TabContentContainer } from '../../../../shared/components/tabs/tabsContainer.component';
import { ContentLoading } from '../../../../shared/components/loading/loading.component';
import { TabPanel } from '../../../../shared/components/tabs';
import { ClientsTab, IClientsTab } from './tabs/clients/clients.tab';
import { Bakery2bTabs } from '../states/tabState.model';
import { ICompanySettings, SettingsTab } from './tabs/settings/settings.tab';
import { StatisticTab, IStatisticTab } from './tabs/statistic/statistic.tab.tsx';

const Bakery2bDetails: FC = () => {
  const { tab } = useParams() as { tab: Bakery2bTabs };
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const initTabData = useLoaderData() as IInitTabData;
  useEffect(() => {
    const unsubLoading = bakery2bTabLoadingService.sub.loading().subscribe((v) => {
      setLoading(v.isLoading);
    });
    return () => {
      unsubLoading.unsubscribe();
    };
  }, []);

  const handleActiveTab: THandleActiveTab = (_, tab) => {
    if (!loading) {
      transitionService.pub.off();
      bakery2bTabLoadingService.pub.loading(true);
      navigateService.pub.navigateTo(`/settings/bakery2b/${tab}`);
    }
  };

  return (
    <>
      <Tabs
        scrollButtons={false}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
        variant='scrollable'
        value={tab}
        onChange={handleActiveTab}
      >
        <Tab label={t('settings.client_other')} value={Bakery2bTabs.clients} />
        <Tab label={t('settings.settings')} value={Bakery2bTabs.settings} />
        <Tab label={t('settings.statistic')} value={Bakery2bTabs.statistic} />
      </Tabs>
      <TabContentContainer>
        <Box sx={{ flexGrow: 1 }}>
          <ContentLoading {...{ loading }}>
            <TabPanel value={Bakery2bTabs.clients} activeValue={tab}>
              <ClientsTab params={initTabData.clientsTab} />
            </TabPanel>
            <TabPanel value={Bakery2bTabs.settings} activeValue={tab}>
              <SettingsTab params={initTabData.companySettings} />
            </TabPanel>
            <TabPanel value={Bakery2bTabs.statistic} activeValue={tab}>
              <StatisticTab params={initTabData.statisticTab} />
            </TabPanel>
          </ContentLoading>
        </Box>
      </TabContentContainer>
    </>
  );
};

type THandleActiveTab = (evt: SyntheticEvent<Element, Event>, tab: string) => void;

export default Bakery2bDetails;

export interface IInitTabData extends TCompanyConfigs {
  clientsTab: IClientsTab['params'];
  companySettings: ICompanySettings;
  statisticTab: IStatisticTab['params'];
}
